import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { CehrStore } from '../stores/cehr.store';

export const CehrSummaryGuard: CanMatchFn = () => {
  const cehrStore = inject(CehrStore);
  const router = inject(Router);

  if (!cehrStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['cehr', 'cehr-form']);
  }

  return true;
};
